document.addEventListener('DOMContentLoaded', function(){
  var bar     = document.querySelector('.custom-announcement-bar');
  var wrapper = document.querySelector('.site-header__wrapper');
  var main    = document.querySelector('.main-content');
  if (!wrapper) return;

  // 1) Figure out the two heights
  var barH = bar     ? bar.getBoundingClientRect().height   : 0;
  var hdrH = wrapper ? wrapper.getBoundingClientRect().height : 0;

  // 2) Expose them to CSS
  var root = document.documentElement;
  root.style.setProperty('--ann-bar-height',   barH + 'px');
  root.style.setProperty('--site-header-height', hdrH + 'px');

  // 3) Scroll‐up/down logic
  var lastY   = window.pageYOffset;
  var ticking = false;

  window.addEventListener('scroll', function(){
    if (ticking) return;
    window.requestAnimationFrame(function(){
      var currentY = window.pageYOffset;

      // down => hide, up => show
      if (currentY > lastY) {
        wrapper.classList.add('is-hidden');
      } else {
        wrapper.classList.remove('is-hidden');
      }

      lastY   = Math.max(currentY, 0);
      ticking = false;
    });
    ticking = true;
  });
});
